import { createContext, useContext } from 'react';

export interface FilterState {
  clearFilters: () => void;
  fileType: string[];
  setFileType: (value: string[]) => void;
  searchQuery: string;
  setSearchQuery: (value: string) => void;
  createdByUserId: string[];
  setCreatedByUserId: (value: string[]) => void;
  updatedByUserId: string[];
  setUpdatedByUserId: (value: string[]) => void;
  fileSize: string[];
  setFileSize: (value: string[]) => void;
  hasFilters: boolean;
}

export const FilterContext = createContext<FilterState>({
  clearFilters: () => undefined,
  fileType: [],
  setFileType: () => undefined,
  searchQuery: '',
  setSearchQuery: () => undefined,
  createdByUserId: [],
  setCreatedByUserId: () => undefined,
  updatedByUserId: [],
  setUpdatedByUserId: () => undefined,
  fileSize: [],
  setFileSize: () => undefined,
  hasFilters: false,
});

export const useFilterContext = () => useContext(FilterContext);
